import React, { useState } from "react";
import { Input } from "semantic-ui-react";
import './PasswordInput.css';

const PasswordInput = props => {

    const [show, setShow] = useState(false);

    const onClick = e => {
        e.preventDefault();
        setShow(!show);
    }
 
    return (
        <Input
            { ...props }
            className="revealable-password"
            type={show ? "text": "password"}
            action={{ icon: show? 'eye slash': 'eye', onClick, tabIndex: -1, }}
            actionPosition="right"
        />
    )
};

export default PasswordInput;


// WEBPACK FOOTER //
// ./src/components/UI/PasswordInput/PasswordInput.js